import {useFooter} from "../../../hooks/hooks";
import React, {useEffect, useRef, useState} from "react";
import {FloatingBtn} from "../../common/button/FloatingBtn";
import style from "./review.module.scss";
import {LightTextStyle} from "../../common/StyledCommonComponents";
import {ReviewSection1} from "./ReviewSection1";
import {ReviewSection2} from "./ReviewSection2";
import {ReviewSection3} from "./ReviewSection3";
import {useShowOrHide} from "../../../hooks/useShowOrHide";
import {useReviewsGetter} from "./hooks/useReviewsGetter";
import {Trans, useTranslation} from "react-i18next";
import {useLocationHistory} from "../../../hooks/location/useLocationHistory";
import {useReviewFunctions} from "./hooks/useReviewFunctions";
import {ReviewDisplayPosition} from "../../../types/review";

export function ReviewMain() {
  const { t } = useTranslation(["subRealReview"]);
  const { setShowFooter } = useFooter();
  const mainTitleRef = useRef<HTMLHeadingElement>(null);
  const reviewListRef = useRef<HTMLElement>(null);
  const [showMainTitle, setShowMainTitle] = useState(false);
  useShowOrHide({ refCurrent: mainTitleRef.current, setShow: setShowMainTitle });
  const { getReviews } = useReviewsGetter();
  const { getPageNumFromUrl, getPage } = useReviewFunctions();
  const [pageNum, setPageNum] = useState<number | null>(null);

  useLocationHistory({
    callbackOnBack: () => getPage({pageNum, setPageNum, reviewListRef}),
    callbackOnNext: () => getPage({pageNum, setPageNum, reviewListRef}),
  });

  useEffect(() => {
    if (pageNum !== null) {
      getReviews({
        page: pageNum,
      }).then();
    }
    // eslint-disable-next-line
  }, [pageNum]);

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowFooter(true);
    document.title = `리얼 후기 | ${process.env.REACT_APP_TITLE}`;

    setPageNum(getPageNumFromUrl());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPageNumFromUrl]);

  return (
    <main className={style.main}>
      <FloatingBtn />

      <div className={style.titleWrapper}>
        <div className={style.titleEffect}></div>
        <div className={style.title}>
          <h2 className={`${style.text} ${showMainTitle ? style.show : style.hide}`} ref={mainTitleRef}>
            <Trans t={t} i18nKey={"title"} components={[<LightTextStyle></LightTextStyle>]} />
          </h2>
        </div>
      </div>
      <ReviewSection1 />
      <ReviewSection2 />
      <ReviewSection3 reviewListRef={reviewListRef} displayPosition={ReviewDisplayPosition.REVIEW}/>
    </main>
  );
}
